/**
 * Created by ZhangJunPeng on 2017/5/23.
 */

import React from 'react';
import moment from 'moment';
import { ContextMenuTrigger } from 'react-contextmenu';
import classNames from 'classnames';
import {
  ROLES_KEY,
  SEARCH_DAY_VIEW__THE_TIME_INTERVAL_DIV_HEIGHT,
  SEARCH_DAY_VIEW_THE_TIME_INTERVAL,
  SYSTEM_SHOW_MEETING_PRIVATE
} from '../../utils/constants';
import PropTypes from 'prop-types';

class MeetingDiv4Day extends React.Component {
  _startOffset = 2;

  constructor(props) {
    super(props);
    this.countWidth = this.countWidth.bind(this);
    this.countLeft = this.countLeft.bind(this);
    this.countTop = this.countTop.bind(this);
  }

  countWidth() {
    const { meeting } = this.props;
    if(moment(meeting.startTime).dayOfYear() == moment(meeting.endTime).dayOfYear()){
      const divNum =
        (meeting.endTime - meeting.startTime) / SEARCH_DAY_VIEW_THE_TIME_INTERVAL;
      return (divNum * window._liWidth) / 2 - this._startOffset - 1;
    }else{
      const divNum =
        (meeting.endTime - meeting.startTime) / SEARCH_DAY_VIEW_THE_TIME_INTERVAL;
      return (divNum * window._liWidth) / 2 - this._startOffset - 1;
    }
  }

  countLeft() {
    const { meeting } = this.props;
    const betweenTime =
      meeting.startTime -
      moment(meeting.startTime)
        .hour(0)
        .minute(0)
        .second(0)
        .millisecond(0)
        .valueOf();
    return (
      ((betweenTime / SEARCH_DAY_VIEW_THE_TIME_INTERVAL) * window._liWidth) /
        2 +
      this._startOffset
    );
  }

  countTop() {
    const { index, continuousDay } = this.props;
    if (continuousDay)
      return index * (SEARCH_DAY_VIEW__THE_TIME_INTERVAL_DIV_HEIGHT - 30) + 68;
    return index * (SEARCH_DAY_VIEW__THE_TIME_INTERVAL_DIV_HEIGHT - 30) + 38;
  }

  makeContent(flag, flag2, meeting, flag3) {
    if (!(flag || flag2)) {
      return meeting.name;
    } else {
      const endTime = moment(meeting.endTime);
      if (endTime.isBefore(moment())) {
        return meeting.name;
      }
      if (flag3) {
        return meeting.name;
      }
    }
  }

  render() {
    const { meeting, roomId, meetingPolicy: { showMeetingPrivateInfo }, userInfo = {} } = this.props;
    const { userId, roleKey } = userInfo;
    const time = `${moment(meeting.startTime).format('HH:mm')}-${moment(
      meeting.endTime
    ).format('HH:mm')}`;
    const flag =
      meeting.creatorId === userId || meeting.holdId === userId;
    const over = meeting.status === 2 || meeting.status === 4;
    let flag2 = false;
    if (meeting.hasOwnProperty('members')) {
      flag2 = (meeting.members + ';').indexOf(userId + ';') !== -1;
    }
    let meetingStatus =
      meeting.status == 4
        ? '(' + this.props.intl.formatMessage({ id: 'meeting_rejected' }) + ')'
        : meeting.status == 5
          ? '(' +
            this.props.intl.formatMessage({ id: 'meeting_no_approved' }) +
            ')'
          : '';
    const divClass = classNames({
      'my-meetings': flag,
      approval_meeting: flag2,
      available: true,
      'ul2-1': true
    });
    /**
     * 获取会议标题
     *
     */
    const getMeetingTitle = (meeting, showMeetingPrivateInfo) => {
      // 当前登陆人是创建人
      const isMyCreate = meeting.creatorId === userId || meeting.holdId === userId;
      // 当前登陆人是参会人
      const isMyMeeting = meeting.hasOwnProperty('members') ? (((meeting.members + ';').indexOf(userId + ';') === -1 ) ? false : true) : false;
      if(showMeetingPrivateInfo === SYSTEM_SHOW_MEETING_PRIVATE.yes) {
        // 允许公开会议主题和预订人信息
        return meeting.name + ', ' + meeting.holder;
      } else {
        // 不允许公开会议主题和预订人信息
        if(roleKey === ROLES_KEY.admin) {
          // 系统管理员
          return meeting.name + ', ' + meeting.holder;
        }
        if(roleKey === ROLES_KEY.room_admin && meeting.roomAdmins.indexOf(userId) !== -1) {
          // 会议室管理员，可查询自己管理会议室下的所有会议
          return meeting.name + ', ' + meeting.holder;
        }
        // 普通用户, 只能看到参会人有自己的会议
        return (isMyCreate || isMyMeeting) ? meeting.name + ', ' + meeting.holder : '';
      }
    };

    const meetingInfo = getMeetingTitle(meeting, showMeetingPrivateInfo);

    return (
      <div
        className={divClass}
        style={{
          width: `${this.countWidth()}px`,
          maxHeight: '25px',
          left: `${this.countLeft()}px`,
          top: `${this.countTop()}px`
        }}
        title={`${time}  ${meetingInfo} ${meetingStatus}`}
      >
        <ContextMenuTrigger id={`right_menu_${meeting.id}_${roomId}`}>
          <span className={over ? 'span_over' : ''}>
            <i>
            {
              meetingInfo ? meetingInfo : time
            }
            </i>
          </span>
        </ContextMenuTrigger>
      </div>
    );
  }
}

MeetingDiv4Day.propTypes = {
  meeting: PropTypes.object.isRequired,
  index: PropTypes.number.isRequired
};

export default MeetingDiv4Day;



// WEBPACK FOOTER //
// ./src/components/meeting/MeetingDiv4Day.js